/* GRANDEVO theme — core interactions (drawers, cart drawer, gallery, analytics hook). No dependencies. */
(function () {
  'use strict';
  const GV = (window.GV = window.GV || {});

  /* ---------- analytics: publishes custom events to Shopify Customer Events (custom pixels can subscribe) ---------- */
  GV.track = function (name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('grandevo_' + name, data || {});
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('grandevo:' + name, { detail: data || {} }));
  };

  GV.money = function (cents) {
    const fmt = GV.moneyFormat || '${{amount}}';
    const v = (Number(cents) || 0) / 100;
    const two = v.toFixed(2), parts = two.split('.');
    const withSep = (sep, dec) => parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec ? dec + parts[1] : '');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withSep(',', '').split('.')[0];
      if (k === 'amount_with_comma_separator') return withSep('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep('.', '').split(',')[0];
      return withSep(',', '.');
    });
  };

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.querySelectorAll('[aria-controls="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = d.querySelector('button,a,input,select');
    if (f) setTimeout(() => f.focus(), 50);
    if (id === 'CartDrawer') GV.renderCart();
    return true;
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  GV.openDrawer = openDrawer;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) {
      if (o.dataset.drawerOpen === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(o.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    const c = e.target.closest('[data-drawer-close]');
    if (c) closeDrawer(c.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('[data-drawer].is-open').forEach(closeDrawer);
  });

  /* ---------- cart ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  GV.fetchCart = () => fetch((GV.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  GV.updateCount = function (cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  };
  GV.renderCart = function () {
    const body = document.querySelector('[data-cart-drawer-body]');
    if (!body) return Promise.resolve();
    const i18nEl = document.querySelector('[data-cart-i18n]');
    const i18n = i18nEl ? JSON.parse(i18nEl.textContent) : { empty: 'Your cart is empty', remove: 'Remove' };
    return GV.fetchCart().then((cart) => {
      GV.updateCount(cart);
      const sub = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = GV.money(cart.total_price);
      if (!cart.items.length) { body.innerHTML = '<p class="muted">' + esc(i18n.empty) + '</p>'; return; }
      body.innerHTML = cart.items.map((it, i) => {
        const props = Object.entries(it.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_')
          .map(([k, v]) => '<li>' + esc(k) + ': ' + esc(v) + '</li>').join('');
        const img = it.image ? '<img src="' + esc(it.image) + '&width=200" alt="" loading="lazy" width="96" height="96">' : '';
        return '<div class="cart-line"><div class="media">' + img + '</div><div><a href="' + esc(it.url) + '" style="text-decoration:none"><strong>' + esc(it.product_title) + '</strong></a>' +
          (it.variant_title ? '<div class="small muted">' + esc(it.variant_title) + '</div>' : '') +
          '<ul class="cart-line__props">' + props + '</ul><div class="small" style="margin-top:6px">× ' + it.quantity + '</div>' +
          '<button type="button" class="link-arrow" style="background:none;border:0;margin-top:8px;cursor:pointer" data-remove-line="' + (i + 1) + '">' + esc(i18n.remove) + '</button></div>' +
          '<div>' + GV.money(it.final_line_price) + '</div></div>';
      }).join('');
    });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-remove-line]');
    if (!b) return;
    fetch(GV.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.removeLine), quantity: 0 }) })
      .then(() => (document.body.classList.contains('template-cart') ? location.reload() : GV.renderCart()));
  });
  GV.addToCart = function (items) {
    return fetch(GV.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then((r) => r.json().then((j) => { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }))
      .then((j) => { GV.track('add_to_cart', { items: items.map((i) => ({ id: i.id, quantity: i.quantity })) }); openDrawer('CartDrawer'); return j; });
  };

  /* product forms using ajax (progressive enhancement over native form post) */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: {} };
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) item.properties[m[1]] = v; }
    const btn = f.querySelector('[type=submit]'); const msg = f.querySelector('[data-form-msg]');
    if (btn) btn.disabled = true;
    GV.addToCart([item]).catch((err) => { if (msg) { msg.hidden = false; msg.textContent = err.message || (GV.strings && GV.strings.error); } })
      .finally(() => { if (btn) btn.disabled = false; });
  });

  /* checkout tracking hook (standard checkout_started/completed events are emitted by Shopify itself) */
  document.addEventListener('click', (e) => { if (e.target.closest('[name="checkout"]')) GV.track('begin_checkout', {}); });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = Number(input.min || 1);
    input.value = Math.max(min, (Number(input.value) || min) + Number(b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('.gallery__slides');
    const thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }));
    if (track) track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, j) => t.setAttribute('aria-current', i === j ? 'true' : 'false'));
    }, { passive: true });
  });

  /* ---------- variant pickers on product page ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const form = document.querySelector(root.dataset.form);
    const update = () => {
      const chosen = [...root.querySelectorAll('fieldset')].map((fs) => (fs.querySelector('input:checked') || {}).value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      const idInput = form && form.querySelector('[name=id]');
      if (v && idInput) idInput.value = v.id;
      const price = document.querySelector('[data-product-price]');
      if (price && v) price.textContent = GV.money(v.price);
      const btn = form && form.querySelector('[data-add-btn]');
      if (btn) btn.disabled = !(v && v.available);
      if (v) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    };
    root.addEventListener('change', update);
  });

  /* ---------- product view tracking ---------- */
  const pv = document.querySelector('[data-product-json]');
  if (pv) { try { const p = JSON.parse(pv.textContent); GV.track('view_product', { id: p.id, handle: p.handle, sku: p.sku }); } catch (e) {} }

  document.addEventListener('DOMContentLoaded', () => { if (document.querySelector('.mobile-sticky')) document.body.classList.add('has-sticky'); });
})();
